import React from "react";
import { Modal, ModalBody } from "react-bootstrap";
import { PngImages, SvgImages } from "../Utils/LocalImages";
import Image from "../Components/Reusable/Image";
import SubmitButton from "../Components/Reusable/Buttons";
import { Link } from "react-router-dom";
import RoutesPath from "../Utils/RoutesPath";

const HomeBannerModal = ({ showModal, setShowModal }) => {
  return (
    <Modal
      show={showModal}
      onHide={() => setShowModal(false)}
      style={{ width: "auto" }}
      dialogClassName="home-banner-modal-dialog"
      centered
      contentClassName="p-0 bg-transparent border-0 shadow-none m-0 w-auto"
    >
      <ModalBody className="p-0" style={{}} >
        <div className="d-flex flex-column home-banner-modal">
          <Image className="align-self-end cursor-pointer" src={SvgImages.close} style={{ width: 30 }} onClick={() => {
            setShowModal(false);
          }} />

          <div className="home-banner-content-container d-flex align-items-center justify-content-center">
            <div className="d-flex flex-column gap-4 w-100">
              <div className="d-flex flex-column gap-3">
                <h3 className='Small-Heading black mb-0 fw-600'>Claim Your</h3>
                <h3 className='Heading orangeAccentColor mb-0 fw-600'>FREE MOCKTEST</h3>
                <Image className="w-50 mx-2" src={SvgImages.mockTestUnderline} style={{ marginTop: -12 }} />
              </div>

              <div className="d-flex flex-column gap-3">
                <div className="d-flex gap-2 align-items-center">
                  <Image src={SvgImages.homeBannerModalbullet} style={{ height: 18 }} />
                  <h3 className='Sub-Heading black mb-0 fw-500'>One free Mock test on registration of  Bharat SAT examination</h3>
                </div>

                <div className="d-flex gap-2 align-items-center">
                  <Image src={SvgImages.homeBannerModalbullet} style={{ height: 18 }} />
                  <h3 className='Sub-Heading black mb-0 fw-500'>Gives real time exam experience</h3>
                </div>

                <div className="d-flex gap-2 align-items-center">
                  <Image src={SvgImages.homeBannerModalbullet} style={{ height: 18 }} />
                  <h3 className='Sub-Heading black mb-0 fw-500'>Improves time management skills</h3>
                </div>
              </div>

              <Link to={RoutesPath.studentRegistration}>
                <SubmitButton title={"Register Now"} />
              </Link>
            </div>

            <Image className="home-banner-image" src={PngImages.HomeBannerImage} />
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default HomeBannerModal;
